import React from "react";
import styles from "./CardHeaderPage.module.scss";

const CardHeaderPage = ({ text, textAlign,backgroundColor,width}) => {
  return <div className={styles.container} style={{textAlign:textAlign,backgroundColor:backgroundColor, width:width}}>{text}</div>;
};

export default CardHeaderPage;
